<template>
  <section class="container">
    <div class="user" :style="{backgroundImage:'url(' + require('@/assets/user_images/head-bg.gif') + ')'}">
      <div class="user__check">
        <!-- @click="$router.push({name:'Setting-Home'})" -->
        <van-icon name="setting-o" color="white" size="20" @click="linkComponents" />
        <van-icon name="notes-o" color="white" size="20" @click="linkComponents" />
      </div>
      <div class="user__top">
        <div class="user__top__info">
          <div class="user__top__info__name" v-if="userInfo.hasData">
            {{ userInfo.nickname }}
          </div>
          <div class="user__top__info__phone" v-if="!userInfo.phone&&isCrossPlatform" @click="getUserInfo">手机号码绑定</div>
          <div class="user__top__info__phone" v-else @click="GoPage('ChangePhone')">{{userInfo.phone}}</div>
        </div>
        <div class="user__top__header">
          <van-image round fit="cover" width="10vh" height="10vh" :src="userInfo.headimgurl" />
        </div>
      </div>
      <div class="user__amount">
        <el-row :gutter="40" class="panel-group">
          <div class="header-card">
            <div class="header-card-body">
              <div class="header-info-list" v-if="config.projectName=='YNTC'">
                <span class="header-info-title">优惠券：{{coupon?coupon:0}}</span>
                <count-to :start-val="0" :end-val="0" :duration="3600" class="header-info-num" />
              </div>
              <!-- <div class="header-info-list">
                <span class="header-info-title">余额：0</span>
                <count-to :start-val="0" :end-val="1" :duration="3600" class="header-info-num" />
              </div> -->
              <div class="header-info-list" v-if="config.projectName=='YNTC'">
                <span class="header-info-title">积分：{{integral?integral:0}}</span>
                <count-to :start-val="0" :end-val="1" :duration="3600" class="header-info-num" />
              </div>
            </div>
          </div>
        </el-row>
      </div>
    </div>

    <div class="toolkit">
      <van-cell-group class="toolkit__menus">
        <van-cell title="我的车辆" size="large" is-link to="my-car">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="myCar" />
        </van-cell>
        <van-cell title="我的钱包" size="large" is-link to="wallet">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="wallet" />
        </van-cell>
      </van-cell-group>
      <van-cell-group class="toolkit__menus">
        <!-- <van-cell title="共享停车" size="large" is-link :to="{name:'Reserve-Parking'}">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="reserve" />
        </van-cell> -->
      </van-cell-group>
      <!-- <van-cell-group class="toolkit__menus">
        <van-cell title="电子发票" size="large" is-link to="invoice">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="invoice" />
        </van-cell>
      </van-cell-group> -->
      <van-cell-group class="toolkit__menus">
        <van-cell title="缴费记录" size="large" is-link to="invoice">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="order" />
        </van-cell>
        <!-- <van-cell v-if="config.projectName!='YNTC'" title="车牌认证" size="large" is-link to="certificates">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="authentication" />
        </van-cell> -->
      </van-cell-group>
      <van-cell-group class="toolkit__menus">
        <!-- <van-cell v-if="config.projectName!='YNTC'" title="月卡管理" size="large" is-link to="month-card">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="monthCard" />
        </van-cell> -->

        <!-- <van-cell v-else title="预充值" size="large" is-link @click="linkComponents">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="monthCard" />
        </van-cell> -->
        <van-cell title="客服帮助" size="large" is-link to="customer-service">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="help" />
        </van-cell>
        <!-- <van-cell title="意见反馈" size="large" is-link url="https://www.wjx.top/vj/Q0fEnJ1.aspx">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="feedback" />
        </van-cell> -->
        <!-- <van-cell v-else title="客服帮助" size="large" is-link @click="linkPhone">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="help" />
        </van-cell> -->
        <van-cell v-if="show" title="清除缓存" size="large" is-link @click="clean">
          <svg-icon slot="icon" class="toolkit__menus__icon" icon-class="cache" />
        </van-cell>
      </van-cell-group>
    </div>

    <div class="footer">
      <div class="copyright_info">
        Copyright ©
        {{$enumObject.providerConfig[config.projectName].copyrightInfo.subject}}
      </div>
    </div>
  </section>
</template>

<script>
import { CellGroup, Grid, GridItem, Row, Icon, Dialog } from 'vant'
import { getUserIntegral } from '@/api/integral'
import { getCouponSize } from "@/api/coupon";
import config from '@/config/index'
import { mapGetters } from 'vuex'
import { isWhatsPayWay } from '@/utils'

import { getToken, removeToken } from '@/utils/auth'
export default {
  name: 'Personal-Center',
  components: {
    [CellGroup.name]: CellGroup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Row.name]: Row,
    [Icon.name]: Icon,
  },
  computed: {
    ...mapGetters([
      'wx_userInfo',//微信用户信息
      'wx_portrait',//微信头像、昵称等
      'wx_token',//微信access_token
      'token',//平台userId
      'NBPSS',//平台用户信息

    ]),
    userInfo () {
      let temp = {
        nickname: '暂无',
        headimgurl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        phone: null
      }
      if (this.wx_portrait && this.wx_portrait.nickname) {// 微信头像昵称
        temp.nickname = this.wx_portrait.nickname
        temp.headimgurl = this.wx_portrait.headimgurl
        temp.hasData = true
        if (this.NBPSS && this.NBPSS.phone) {
          temp.phone = this.NBPSS.phone
        } else {
          temp.phone = null
        }
      } else if (this.NBPSS && this.NBPSS.phone) {
        temp.phone = this.NBPSS.phone
        if (this.NBPSS.name && this.NBPSS.picture1) {
          temp.nickname = this.NBPSS.name
          temp.headimgurl = this.NBPSS.picture1
        }
      } else {
        temp.hasData = false
      }
      return temp
    }
  },
  data () {
    return {
      show: true,
      listQuery: {
        //过滤参数
        page: 1,
        limit: 999999,
      },
      integral: 0,
      coupon: 0,
      config,
      isCrossPlatform: false,
      getInfo_Loading: null
    }
  },
  mounted () {
    this.show = isWhatsPayWay() == 'WX' ? true : false
    this.isCrossPlatform = this.$enumObject.providerConfig[config.projectName].CrossPlatform
    this.$store.dispatch('GetWXUserInfo', { openid: this.NBPSS ? this.NBPSS.openid : this.wxapi_userinfo ? this.wxapi_userinfo.openid : "" })//获取用户头像等信息
    // getUserIntegral().then(res => {
    //   this.integral = Object.keys(res.body).length > 0 ? res.body.growthScore : 0;
    // }).catch(err => {
    //   this.$notify({
    //     type: 'danger',
    //     message: err
    //   })
    // })
    // 优惠券
    if (config.projectName == 'YNTC') {
      let params = {
        startPage: this.listQuery.page,
        pageSize: this.listQuery.limit,
      }
      getCouponSize(params).then(res => {
        this.coupon = res.body.length
      }).catch(err => {
        this.$notify({
          type: 'danger',
          message: err
        })
      })
    }
  },
  methods: {
    // 清除缓存
    clean () {
      localStorage.clear();
      removeToken('NineBit_Authorization')
      removeToken('Wx_Authorization')
      // removeToken('Zfb_Authorization')
      removeToken('verify_condition')
      this.$toast('清除成功')
      location.reload()
    },
    // 图标跳转
    GoPage () {
      this.$router.push('/ChangePhone')
    },
    //登录并获取用户信息
    getUserInfo () {
      this.$router.push('/login')
    },
    // 客服号码
    linkPhone () {
      Dialog.alert({
        title: '监督服务电话',
        confirmButtonColor: '#1989fa',
        message: '0883-2655999',
      }).then(() => {
        // on close
      });
    },
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100vh;
  background: rgb(243, 244, 245);
  padding-bottom: 10px;
  box-sizing: border-box;

  .user {
    width: 100%;
    height: 28vh;
    min-height: 140px;
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    @keyframes move_wave {
      0% {
        transform: translateX(0) translateZ(0) scaleY(1);
      }
      50% {
        transform: translateX(-25%) translateZ(0) scaleY(0.55);
      }
      100% {
        transform: translateX(-50%) translateZ(0) scaleY(1);
      }
    }
    .waveWrapper {
      overflow: hidden;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
    }
    .waveWrapperInner {
      position: absolute;
      width: 100%;
      overflow: hidden;
      height: 100px;
      bottom: -1px;
    }
    .bgTop {
      z-index: 15;
      opacity: 0.5;
    }
    .bgMiddle {
      z-index: 10;
      opacity: 0.75;
    }
    .bgBottom {
      z-index: 5;
    }
    .wave {
      position: absolute;
      left: 0;
      width: 280%;
      height: 100px;
      background-repeat: repeat no-repeat;
      background-position: 0 bottom;
      transform-origin: center bottom;
    }
    .waveTop {
      background-size: 100% 45px;
    }
    .waveAnimation .waveTop {
      animation: move-wave 3s;
      -webkit-animation: move-wave 3s;
      -webkit-animation-delay: 1s;
      animation-delay: 1s;
    }
    .waveMiddle {
      background-size: 100% 55px;
    }
    .waveAnimation .waveMiddle {
      animation: move_wave 10s linear infinite;
    }
    .waveBottom {
      background-size: 100% 45px;
    }
    .waveAnimation .waveBottom {
      animation: move_wave 15s linear infinite;
    }
    &__check {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-top: 5px;
      i {
        padding: 3px;
        margin-right: 15px;
      }
    }
    &__top {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      &__header {
        width: 10vh;
        height: 10vh;
        border-radius: 100%;
        border: 2px solid #ffffff;
      }

      &__info {
        width: 60%;
        height: 60px;
        display: flex;
        text-align: left;
        flex-wrap: wrap;
        align-items: center;

        div {
          color: #fff;
        }

        &__name {
          width: 100%;
          line-height: 26px;
          font-size: 24px;
        }

        &__phone {
          width: 100%;
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
    &__amount {
      text-align: center;
      font-size: 14px;
      width: 100%;
      .panel-group {
        .header-card {
          box-sizing: border-box;
          margin-top: 5px;
          padding: 0 20px 0;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          font-variant: tabular-nums;
          line-height: 1.5;
          list-style: none;
          font-feature-settings: "tnum";
          position: relative;
          border-radius: 2px;
          transition: all 0.3s;
          .header-card-body {
            padding: 5px;
            zoom: 1;
            display: flex;
            .header-info-list {
              text-align: center;
              flex: 1;
              line-height: 28px;
              .header-info-title {
                display: inline-block;
                margin-bottom: 4px;
                color: white;
                font-size: 16px;
                line-height: 18px;
              }
              .header-info-num {
                margin: 0;
                color: white;
                font-size: 1.75rem;
                line-height: 42px;
                letter-spacing: 0.625px;
                display: block;
              }
            }
            .header-info-list:not(:last-child) {
              border-right: 1px solid #5aade0;
            }
          }
        }
      }
    }
  }

  .toolkit {
    padding-top: 20px;

    &__menus {
      margin-bottom: 10px;

      &__icon {
        font-size: 20px;
        line-height: 24px;
        margin-right: 5px;
        height: 24px;
      }
    }

    &__menus:last-child {
      margin-bottom: 0;
    }
  }

  .footer {
    width: 100%;
    // position: absolute;
    // bottom: 0;
    // left: 0;
    height: 50px;
    text-align: center;
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    // padding: 13px 0 13px;
  }
}
</style>